export default __webpack_public_path__ + "static/media/product10.711556a3.webp";